import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import { LEDGER_TYPE_LABELS } from '../../../constants/ledger.constants';
import { TRANSACTION_TYPE_TONE_BY_TYPE, TRANSACTION_TYPE_TONE_FALLBACK } from './transactionTypeTag.constants';
import styles from '../styles/status-pill-tag.module.scss';

/**
 * Tag for the TYPE column of a ledger transactions table (Figma node
 * 5747:1242). Tone is resolved via `TRANSACTION_TYPE_TONE_BY_TYPE`; unknown
 * types fall back to the neutral tone so new backend values never break the
 * render.
 *
 * Lives in `common/` rather than next to the reports table it was written for:
 * reports, support and the shared LedgerTable all render it, and a component in
 * `common/` reaching into a feature folder points the dependency the wrong way.
 */
function TransactionTypeTag({ type }) {
    const tone = TRANSACTION_TYPE_TONE_BY_TYPE[type] || TRANSACTION_TYPE_TONE_FALLBACK;
    const label = (LEDGER_TYPE_LABELS[type] || type || '').toString().toUpperCase();

    return (
        <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={`${styles.tag} ${styles[`tone_${tone}`]}`}>
            {label}
        </Text>
    );
}

export default TransactionTypeTag;
